/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnswerTo } from '../../models/answer-to';

export interface ApiWebCzyIdentyfikatorTrWolnyGet$Params {
  identyfikatorTr: string;
  nip: string;
}

export function apiWebCzyIdentyfikatorTrWolnyGet(http: HttpClient, rootUrl: string, params: ApiWebCzyIdentyfikatorTrWolnyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
  const rb = new RequestBuilder(rootUrl, apiWebCzyIdentyfikatorTrWolnyGet.PATH, 'get');
  if (params) {
    rb.query('identyfikatorTr', params.identyfikatorTr, {});
    rb.query('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnswerTo>;
    })
  );
}

apiWebCzyIdentyfikatorTrWolnyGet.PATH = '/api/web/czy/identyfikatorTrWolny';
